import Container from 'typedi';
import ItemRepository from '../repositories/ItemRepository';

class ItemService {
  itemRepository;
  constructor() {
    this.itemRepository = Container.get(ItemRepository);
  }
  getTypes = async () => await this.itemRepository.getTypes();
  getItems = async () => await this.itemRepository.getItems();
  getItemsPerPage = async (page, rowsPerPage) => await this.itemRepository.getItemsPerPage(page, rowsPerPage);
  getItemsByIdDocumentOp = async (idDocument) => await this.itemRepository.getItemsByIdDocumentOp(idDocument);
  getItemsByIdDocument = async (idDocument) => await this.itemRepository.getItemsByIdDocument(idDocument);

  processMassiveItemSubmission(items, itemTypes) {
    const requestItems = [];
    if (items.length) {
      items.forEach((item) => {
        const respectiveItem = itemTypes.find((e) => e.name === item.itemType);
        if (!respectiveItem) console.log(item, itemTypes);
        const { idItem, name, description, extra1, extra2, extra3, extra4, extra5, code } = respectiveItem;
        requestItems.push({
          status: 1,
          idItemData: respectiveItem.id,
          quantity: Number(item.itemQuantity),
          idItem,
          name,
          description,
          extra1,
          extra2,
          extra3,
          extra4,
          extra5,
          code,
          unitPrice: item.itemUnitPrice ? item.itemUnitPrice : 0,
        });
      });
    }
    return requestItems;
  }
}

Container.set({ id: ItemService, type: ItemService });

export default ItemService;
